import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card, Table, List, Tabs, Radio, Button } from 'antd';
import { EmptyState } from '../empty_state/EmptyState';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import UserNotificationRowDisplay from '../user_notification_row_display/UserNotificationRowDisplay';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';
import { USER_NOTIFICATIONS_CRUD_ACTION_CREATORS } from '../../actions/user_notifications_actions';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { isEqual } from 'lodash';

const { Content } = Layout;

const style = require('./NotificationsIndexPage.less');

const NOTIFICATIONS_OVERVIEW_TARGET_COLLECTION = 'notificationsIndex';

function NotificationsIndexPage(props) {
	const { userNotifications, userType } = props;
	const notificationsFetching = userNotifications.fetching;

	const formatNotifications = (notification) => ({
		...notification,
		title:
			userType === ROLE_TYPES.SUPPLIER
				? nullSafeGet(`supplierPushNotification.webAppMessage`, notification)
				: nullSafeGet(`buyerPushNotification.webAppMessage`, notification),
		datetime: notification.createdAt,
		contact: notification.userContact,
	});

	const NotificationFilters = [
		{
			label: 'All',
			filter: { notificationTypes: undefined },
			key: 'All',
			// icon: 'icons8-wrench',
			// iconStyle: { color: '#4a1e87' },
			count: 0,
			children: null,
		},
		{
			label: 'Status Updates',
			filter: {
				notificationTypes: [
					'WorkOrder',
					'Review',
					'Invoice',
					'SupplierlnitiatedWorkOrder',
					'RFP',
					'PlannedMaintenanceWorkOrder',
				],
			},
			key: 'WorkOrder',
			icon: 'icons8-wrench',
			iconStyle: { color: '#4a1e87' },
			count: 0,
			children: null,
		},
		{
			label: 'Notes',
			filter: { notificationTypes: ['WorkOrderNotes', 'WorkOrderNotesMentions'] },
			key: 'WorkOrderNotes',
			icon: 'icons8-chat-bubble',
			iconStyle: { color: STOPLIGHT_COLORS.pureYellow },
			count: 0,
			children: null,
		},
	];
	const activeFilters = nullSafeGetOrElse(
		`${NOTIFICATIONS_OVERVIEW_TARGET_COLLECTION}.filters`,
		userNotifications,
		{}
	);

	return (
		<Content className="buyerNotificationsIndexPage" style={{ padding: '0 0.5em' }}>
			<Row style={{ margin: '0.5em -8px' }}>
				<Col span={24}>
					<div className="my-4 mx-4 flex flex-row gap-x-1">
						{NotificationFilters.map((filter) => {
							const checkActive = (stage) => {
								if (!activeFilters) {
									return false;
								}

								return Object.keys(stage.filter).every((k) =>
									isEqual(activeFilters[k], stage.filter[k])
								);
							};
							const isActive = checkActive(filter);
							return (
								<Button
									size="large"
									key={filter.label}
									onClick={() => {
										props.updateUserNotificationFilters(
											isActive ? { notificationTypes: undefined } : filter.filter,
											NOTIFICATIONS_OVERVIEW_TARGET_COLLECTION
										);
									}}
									type={isActive ? 'primary' : 'default'}
								>
									<span>
										{filter.icon && (
											<i
												style={{
													...filter.iconStyle,
													marginRight: '8px',
													color: isActive ? '#fff' : filter.iconStyle.color,
												}}
												className={`icons8-font ${filter.icon}`}
											/>
										)}
										{filter.label}
									</span>
								</Button>
							);
						})}
					</div>
				</Col>
				<Col span={24}>
					<div className="mx-4 mb-4 flex flex-row gap-x-1">
						<Radio.Group
							onChange={(e) => {
								props.updateUserNotificationFilters(
									{ hasSeen: e.target.value },
									NOTIFICATIONS_OVERVIEW_TARGET_COLLECTION
								);
							}}
							value={activeFilters.hasSeen}
							optionType="button"
							options={[
								{ label: 'ALL', value: undefined },
								{ label: 'UNREAD', value: false },
							]}
						></Radio.Group>
					</div>
				</Col>
				<Col span={24}>
					<Card>
						<PaginatedReduxTable
							loading={notificationsFetching}
							targetCollectionName={NOTIFICATIONS_OVERVIEW_TARGET_COLLECTION}
							showHeader={false}
							columns={[
								{
									title: '',
									dataIndex: 'title',
									key: 'title',
									render: (title, notification) => (
										<UserNotificationRowDisplay
											showTemplate
											notification={formatNotifications(notification)}
											userType={props.userType}
										/>
									),
								},
							]}
							collectionName={'user_notifications'}
							fetchData={
								props.userType === ROLE_TYPES.SUPPLIER
									? userNotificationsRestCrudThunksForSupplier.read
									: userNotificationsRestCrudThunksForBuyer.read
							}
							emptyState={
								<EmptyState
									graphic={
										<img
											style={{ marginBottom: 8 }}
											src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
										/>
									}
									headline={"You haven't received any notifications yet."}
									body={null}
								/>
							}
							initialFilters={{ notificationTypes: undefined }}
						/>
					</Card>
				</Col>
			</Row>
		</Content>
	);
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	userNotifications: state.user_notifications,
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({
	updateUserNotificationForBuyer: (entity) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.update(entity)),
	updateUserNotificationForSupplier: (entity) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.update(entity)),
	updateUserNotificationFilters: (filters, targetCollection) =>
		dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(NotificationsIndexPage)
);
